/**
 * Finds a username based on a User ID or ObjectMeta Name.
 * @param {string} id - The ID to search for (e.g., from device.UserName).
 * @param {Array} userList - The array of user objects to search.
 * @returns {string} - The actual username (Spec.UserName) or the original ID if not found.
 */
export const getUserNameById = (id, userList = []) => {
  if (!id) return ''

  const foundUser = userList.find((user) => user?.ObjectMeta?.Name === id)

  if (!foundUser) return id

  const { Spec } = foundUser

  // Return UserName if it's a non-empty string; otherwise FullName if present; else id
  if (Spec?.UserName?.trim() !== '') return Spec.UserName
  if (Spec?.FullName?.trim() !== '') return Spec.FullName

  return id
}
